import * as React from "react";
import { Box } from "@mui/material";

export const InputBox = (props: any) => {
  return (
    <Box sx={{ display: "flex", flexWrap: "nowrap" }}>{props.children}</Box>
  );
};

